module.exports = __webpack_public_path__ + "media/images/city_img/l-14fb6000cf28702a0a6faac1ae2475ed.jpg";